import { render, staticRenderFns } from "./ActionType.vue?vue&type=template&id=0b328fae&"
import script from "./ActionType.vue?vue&type=script&lang=js&"
export * from "./ActionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports